export const CARD_NUMBER_INVALID_ERROR_CODE = 'CARD_NUMBER_INVALID';
